<template>
    <div>
        <div class="card">
            <div class="card-header text-black p-2">Appointments</div>
            <div class="card-body p-2">
                <div class="overflow-auto" style="max-height: 300px;">
                    <table class="table hm-fs-12 align-middle table-hover table-sm mb-0">
                        <thead>
                            <tr class="sticky-top">
                                <th class="bg-theme">Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr
                                v-if="Object.keys(appointments).length > 0"
                                v-for="(appointment, index) in appointments"
                            >
                                <td @click="$goToPage(`/admin/appointments/${appointment.id}/edit`)" class="cursor-pointer">
                                    <div class="d-flex justify-content-between">
                                        <span class="text-capitalize">{{ appointment.title }}</span>
                                        <span>{{$dateTimeFormat((appointment.appointment_date + ' ' + appointment.start_time), 'hh:mm a') }}</span>
                                    </div>
                                </td>

                            </tr>
                            <tr v-else-if="isLoadingAppointments">
                                <td class="text-center">Loading...</td>
                            </tr>
                            <tr v-else>
                                <td class="text-center">No appointments found for today.</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AppointmentSummary",
    data() {
        return {
            appointments: [],
            isLoadingAppointments: true
        }
    },
    mounted() {
        this.getStats();
    },
    methods: {
        getStats() {
            let self = this;
            axios.post('/admin/dashboard/stats?action=appointments', {action: 'appointments'})
                .then(response => {
                    // Get order summary
                    self.appointments = response.data;
                    self.isLoadingAppointments = false;
                });
        },
    }
}
</script>
